import { groupBy, orderBy } from "lodash";
import { Item__Atividades } from "../../../../../../../services/atividades/GET";

export const unidade_medida_local = [
    { cod: 1, nome_completo: 'L/ha', nome: 'L', nome_filtro: 'l', tipo_fisico: 'Líquido' },
    { cod: 2, nome_completo: 'mL/ha', nome: 'mL', nome_filtro: 'ml', tipo_fisico: 'Líquido' },
    { cod: 3, nome_completo: 'Kg/ha', nome: 'Kg', nome_filtro: 'kg', tipo_fisico: 'Sólido' },
    { cod: 4, nome_completo: 'g/ha', nome: 'g', nome_filtro: 'g', tipo_fisico: 'Sólido' },
    { cod: 5, nome_completo: 'sc/ha', nome: 'sc', nome_filtro: 'sc', tipo_fisico: 'Sólido' },
    { cod: 6, nome_completo: 'Kg/ha', nome: 'Kg', nome_filtro: 'kg', tipo_fisico: 'Sólido' },
    { cod: 7, nome_completo: 't/ha', nome: 't', nome_filtro: 't', tipo_fisico: 'Sólido' },
    { cod: 8, nome_completo: '@/ha', nome: '@', nome_filtro: '@', tipo_fisico: 'Sólido' },
    { cod: 9, nome_completo: 'sementes/ha', nome: 'sementes', nome_filtro: 'sementes', tipo_fisico: 'Sementes' },
    { cod: 10, nome_completo: '%', nome: '%', nome_filtro: '%', tipo_fisico: 'Líquido' },
    { cod: 11, nome_completo: 'g/L', nome: 'g/L', nome_filtro: 'g/l', tipo_fisico: 'Líquido' },
    { cod: 12, nome_completo: 'Dose/ha', nome: 'Dose', nome_filtro: 'dose', tipo_fisico: 'Líquido' },
    { cod: 16, nome_completo: 'g/kg de semente', nome: 'g/kg de semente', nome_filtro: 'g/kg de semente', tipo_fisico: 'Sólido' },
    { cod: 17, nome_completo: 'mL/kg de semente', nome: 'mL/kg de semente', nome_filtro: 'mL/kg de semente', tipo_fisico: 'Líquido' },
    { cod: 18, nome_completo: 'L/tanque de pulverização', nome: 'L/tanque de pulverização', nome_filtro: 'L/tanque de pulverização', tipo_fisico: 'Líquido' },
];

export function obterNomeMediaLocal(cod_medida: number) {
    const medida = unidade_medida_local.find(i => i.cod === cod_medida);
    return {
        nome: medida?.nome,
        nome_completo: medida?.nome_completo,
        nome_filtro: medida?.nome_filtro,
        tipo_fisico: medida?.tipo_fisico
    };
};

export function normarlizarEmKg(quantidade: number, cod_medida: number) {
    //já está em kg
    if (cod_medida === 3 || cod_medida === 6) {
        return quantidade;
    }

    //transformar t em kg
    if (cod_medida === 7) {
        return quantidade * 1000;
    }

    //transformar g em kg
    if (cod_medida === 4) {
        return quantidade / 1000;
    }

    return 0;
}

export function obterCodInsumoDashboard(item_insumo: any) {
    switch (item_insumo?.cod_tipo) {
        case 1:
            return item_insumo?.cod_produto;
        case 2:
            return item_insumo?.cod_variedade_hibrido;
        case 3:
            return item_insumo?.cod_fertilizante;
        case 4:
            return item_insumo?.cod_produto;
        case 5:
            return item_insumo?.cod_produto;
        case 6:
            return item_insumo?.cod_produto;
        case 8:
            return item_insumo?.cod_produto;
        case 9:
            return item_insumo?.cod_produto;
        default:
            return null;
    }
}

export function obterListaInsumosSolidos(todas_atividades_ativas: Item__Atividades[]) {

    const incluir_tipo_atv = (todas_atividades_ativas ?? []).map(i => {
        return {
            ...i, andamentos: (i.andamentos ?? []).map(j => {
                return {
                    ...j, insumos: (j.insumos ?? []).map(k => {
                        return {
                            ...k,
                            tipo_atividade: i.cod_tipo === 1 ? "planejada" : "executada",
                            cod_tipo_atividade: i.cod_tipo
                        }
                    })
                }
            })
        }
    }).filter(i => i.delete_time === null);

    const apenas_insumos = (incluir_tipo_atv ?? []).map(i => {
        return i.andamentos.map(j => {
            return (j.insumos ?? []).map(k => {
                return {
                    cod: k.cod,
                    insumo_nome: k.insumo_nome,
                    cod_produto: k.cod_produto,
                    cod_fertilizante: k.cod_fertilizante,
                    cod_tecnologia: k.cod_tecnologia,
                    cod_variedade_hibrido: k.cod_variedade_hibrido,
                    cod_tipo: k.cod_tipo,
                    cod_tipo_atividade: k.cod_tipo_atividade,
                    composicao: k.composicao,
                    cod_medida: k.cod_medida,
                    dosagem: k.dosagem,
                    maximo_abaixo: k.maximo_abaixo,
                    maximo_acima: k.maximo_acima,
                    quantidade: k.quantidade,
                    tipo_atividade: k.tipo_atividade,
                    nome_medida_filtro: obterNomeMediaLocal(k.cod_medida).nome_filtro,
                    tipo_fisico_medida: obterNomeMediaLocal(k.cod_medida).tipo_fisico,
                    cod_insumo: obterCodInsumoDashboard(k)
                }
            })
        })
        //@ts-ignore
    }).flat(2)?.filter(i => i.cod_tipo !== 8 && i.cod_tipo !== 9);

    const insumos_solidos = apenas_insumos.filter(i => i.tipo_fisico_medida === "Sólido");

    const incluir_qtd_normalizada_em_kg = (insumos_solidos ?? []).map(i => {
        return {
            ...i,
            quantidade_em_kg: normarlizarEmKg(i.quantidade, i.cod_medida)
        }
    });

    const insumos_planejados = (incluir_qtd_normalizada_em_kg ?? []).filter(({ tipo_atividade }) => tipo_atividade === "planejada");
    const insumos_executados = (incluir_qtd_normalizada_em_kg ?? []).filter(({ tipo_atividade }) => tipo_atividade === "executada");

    const agrupar_insumos_planejados = groupBy(insumos_planejados, "insumo_nome");
    const agrupar_insumos_executados = groupBy(insumos_executados, "insumo_nome");

    const totalizar_planejados = Object.entries(agrupar_insumos_planejados).map(([insumo_nome, insumos]) => {
        return {
            insumo_nome,
            quantidade: insumos.reduce((total, insumo) => total + insumo.quantidade_em_kg, 0)
        }
    });

    const totalizar_executados = Object.entries(agrupar_insumos_executados).map(([insumo_nome, insumos]) => {
        return {
            insumo_nome,
            quantidade: insumos.reduce((total, insumo) => total + insumo.quantidade_em_kg, 0)
        }
    });

    const insumos_consolidados: {
        cod_insumo: number | null;
        insumo_nome: string;
        quantidade_planejada: number;
        quantidade_executada: number;
        precisao: number;
        porcentagem: number;
        ordem: number;
    }[] = [];

    // Combine planned and executed data
    const todos_insumos = new Set([...totalizar_planejados.map(i => i.insumo_nome), ...totalizar_executados.map(i => i.insumo_nome)]);

    todos_insumos.forEach(insumo_nome => {
        const primeiro_insumo = (agrupar_insumos_planejados[insumo_nome] || agrupar_insumos_executados[insumo_nome])?.[0];
        const cod_insumo = primeiro_insumo?.cod_insumo || null;

        const planejado = totalizar_planejados.find(i => i.insumo_nome === insumo_nome)?.quantidade || 0;
        const executado = totalizar_executados.find(i => i.insumo_nome === insumo_nome)?.quantidade || 0;

        let precisao = 0;
        let porcentagem = 0;

        if (planejado > 0) {
            const porcentagem_realizada = (executado / planejado) * 100;

            // Precision: 100 - |100 - executed%|
            // Represents how close the execution was to the plan (0-100%)
            precisao = 100 - Math.abs(100 - porcentagem_realizada);
            if (precisao < 0) precisao = 0;

            // Bar Percentage: Visual representation of execution.
            // As per user request: "não precisa compensar os 80%, pode exibir o valor real mesmo"
            // Example: 105% executed -> 105% bar.
            porcentagem = porcentagem_realizada;

        } else if (executado > 0) {
            precisao = 0;
            // Unplanned execution -> Percentage and Precision must be 0 as per user request.
            porcentagem = 0;
        }

        insumos_consolidados.push({
            cod_insumo,
            insumo_nome,
            quantidade_planejada: Number(planejado?.toFixed(2)),
            quantidade_executada: Number(executado?.toFixed(2)),
            precisao: Number(precisao?.toFixed(2)),
            porcentagem: Number(porcentagem?.toFixed(2)),
            ordem: (planejado > 0 && executado > 0) ? 1 : (planejado === 0 && executado > 0) ? 2 : (planejado > 0 && executado === 0) ? 3 : 4
        });
    });

    return orderBy(insumos_consolidados, ["ordem", "quantidade_executada"], ["asc", "desc"]) ?? [];

}